import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import Select from 'react-select';
import * as Routes from 'modules/routes';
import styles from '../index.module.scss';

const ReadingCheckSelects = ({ exerciseId, lessonId, setExerciseId, setHasError }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [readingGames, setReadingGames] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!lessonId) {
      setIsLoading(false);
      return;
    }

    Axios.get(Routes.plato_api_reading_games_path(), {
      params: new URLSearchParams([['for_lesson', lessonId], ['published', 'true']]),
    })
      .then((response) => {
        const games = response.data.reading_games || [];
        setReadingGames(games);

        if (games.length === 0) return;

        const selectedGame = games.find(game => parseInt(game.id, 10) === exerciseId) || games[0];
        const gameOption = {
          label: selectedGame.title,
          value: parseInt(selectedGame.id, 10),
        };
        setSelectedOption(gameOption);
        setExerciseId(gameOption.value);
      })
      .catch(() => {
        setHasError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [lessonId]);

  const options = readingGames.map(game => ({
    label: game.title,
    value: parseInt(game.id, 10),
  }));

  const handleChange = (option) => {
    setSelectedOption(option);
    setExerciseId(option.value);
  };

  if (isLoading) return <></>;
  if (readingGames.length === 0) return <></>;

  return (
    <div className={styles.modelSelect}>
      <label htmlFor="reading-check-select">
        <p>Reading Checks:</p>
      </label>
      <Select
        className={`${styles.select} model-select`}
        id="reading-check-select"
        options={options}
        value={selectedOption}
        onChange={handleChange}
      />
    </div>
  );
};

ReadingCheckSelects.propTypes = {
  exerciseId: PropTypes.number,
  lessonId: PropTypes.number.isRequired,
  setExerciseId: PropTypes.func.isRequired,
  setHasError: PropTypes.func.isRequired,
};

export default ReadingCheckSelects;
